import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loginUser } from '../api/auth';
import AuthShell from './auth/AuthShell';
import styles from './auth/AuthShell.module.css';
import { getAuthCopy } from './auth/authCopy';

const Login = ({ onLogin }) => {
  const { i18n } = useTranslation();
  const copy = getAuthCopy(i18n.language).login;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const invitedUsername = String(searchParams.get('username') || '').trim();

  useEffect(() => {
    if (invitedUsername) {
      setUsername(invitedUsername);
    }
  }, [invitedUsername]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const result = await loginUser({ username, password });
      onLogin(result.user);
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      setMessage(error.message || copy.loginError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      variant="signin"
      eyebrow={copy.eyebrow}
      title={copy.title}
      subtitle={copy.subtitle}
    >
      <form onSubmit={handleLogin} className={styles.formStack}>
        {invitedUsername ? (
          <div className={styles.notice}>
            {copy.invitationNotice.replace('{{username}}', invitedUsername)}
          </div>
        ) : null}

        <div className={styles.formSection}>
          {copy.sectionTitle || copy.sectionText ? (
            <div>
              {copy.sectionTitle ? <h2 className={styles.sectionHeading}>{copy.sectionTitle}</h2> : null}
              {copy.sectionText ? (
                <p className={styles.sectionText}>
                  {copy.sectionText}
                </p>
              ) : null}
            </div>
          ) : null}

          <div className={styles.field}>
            <label className={styles.fieldLabel}>{copy.username}</label>
            <input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              placeholder={copy.usernamePlaceholder}
              className={styles.input}
              autoComplete="username"
            />
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>{copy.password}</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              placeholder={copy.passwordPlaceholder}
              className={styles.input}
              autoComplete="current-password"
            />
          </div>

          {message ? <p className={`${styles.message} ${styles.messageError}`}>{message}</p> : null}

          <button type="submit" className={styles.primaryButton} disabled={loading}>
            {loading ? copy.signingIn : copy.login}
          </button>
        </div>

        <div className={styles.actionRow}>
          <p className={styles.helperText}>
            {copy.requestAccessLead}{' '}
            <button type="button" onClick={() => navigate('/register')} className={styles.linkButton}>
              {copy.requestAccessAction}
            </button>
          </p>
        </div>
      </form>
    </AuthShell>
  );
};

export default Login;
